import fp from 'lodash/fp';
import * as actions from './actions';
import { initialGridSorting } from './constants';

export const INITIAL_STATE = {
    commodityRows: [],
    commodityLoading: false,

    equityCreditRows: [],
    equityCreditLoading: false,

    equityMappingRows: [],
    equityMappingLoading: false,

    isdaRows: [],
    isdaLoading: false,

    standardProductClassRows: [],
    standardProductClassLoading: false,

    currencyMappingRows: [],
    currencyMappingLoading: false,

    isdaMappingDropdownOptions: [],
    commodityMappingDropdownOptions: [],
    standardProductClassDropdown: [],
    currencyMappingDropdown: [],

    fetchedIsdaMappingOptions: false,
    fetchedCommodityMappingOptions: false,
    fetchedProductClassOptions: false,
    fetchedCurrencyOptions: false,

    gridSorting: initialGridSorting
};

const setCommodityRows = fp.set('commodityRows');
const setIsdaRows = fp.set('isdaRows');
const setIceIsinRows = fp.set('equityCreditRows');
const setEquitySedolRows = fp.set('equityMappingRows');
const setProductClassRows = fp.set('standardProductClassRows');
const setCurrencyMappingRows = fp.set('currencyMappingRows');

const setCommodityLoading = fp.set('commodityLoading');
const setEquityCreditLoading = fp.set('equityCreditLoading');
const setEquityMappingLoading = fp.set('equityMappingLoading');
const setIsdaLoading = fp.set('isdaLoading');
const setProductClassLoading = fp.set('standardProductClassLoading');
const setCurrencyMappingLoading = fp.set('currencyMappingLoading');

const setIsdaMappingDropdown = fp.set('isdaMappingDropdownOptions');
const setCommodityMappingDropdown = fp.set('commodityMappingDropdownOptions');
const setStandardProductClassDropdown = fp.set('standardProductClassDropdown');
const setCurrencyMappingDropdown = fp.set('currencyMappingDropdown');

const setFetchedIsdaMappingOptions = fp.set('fetchedIsdaMappingOptions');
const setFetchedCommodityMappingOptions = fp.set('fetchedCommodityMappingOptions');
const setFetchedProductClassOptions = fp.set('fetchedProductClassOptions');
const setFetchedCurrencyOptions = fp.set('fetchedCurrencyOptions');

const sortByField = fp.sortBy('field');
const setGridSorting = fp.set('gridSorting');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_COMMODITY_MAPPING_ROWS: {
            return setCommodityRows(action.data, state);
        }
        case actions.SET_ISDA_CURVE_ROWS: {
            return setIsdaRows(action.data, state);
        }
        case actions.SET_ICE_ISIN_ROWS: {
            return setIceIsinRows(action.data, state);
        }
        case actions.SET_EQUITY_SEDOL_ROWS: {
            return setEquitySedolRows(action.data, state);
        }
        case actions.SET_PRODUCT_CLASS_ROWS: {
            return setProductClassRows(action.data, state);
        }
        case actions.SET_CURRENCY_MAPPING_ROWS: {
            return setCurrencyMappingRows(action.data, state);
        }
        case actions.SET_COMMODITY_LOADING: {
            return setCommodityLoading(action.loading, state);
        }
        case actions.SET_EQUITY_CREDIT_LOADING: {
            return setEquityCreditLoading(action.loading, state);
        }
        case actions.SET_EQUITY_MAPPING_LOADING: {
            return setEquityMappingLoading(action.loading, state);
        }
        case actions.SET_ISDA_LOADING: {
            return setIsdaLoading(action.loading, state);
        }
        case actions.SET_PRODUCT_CLASS_LOADING: {
            return setProductClassLoading(action.loading, state);
        }
        case actions.SET_CURRENCY_MAPPING_LOADING: {
            return setCurrencyMappingLoading(action.loading, state);
        }
        case actions.SET_ISDA_MAPPING_DROPDOWN_OPTIONS: {
            return setIsdaMappingDropdown(action.options, state);
        }
        case actions.SET_COMMODITY_MAPPING_DROPDOWN_OPTIONS: {
            return setCommodityMappingDropdown(action.options, state);
        }
        case actions.SET_PRODUCT_CLASS_DROPDOWN_OPTIONS: {
            return setStandardProductClassDropdown(action.options, state);
        }
        case actions.SET_CURRENCY_DROPDOWN_OPTIONS: {
            return setCurrencyMappingDropdown(action.options, state);
        }
        case actions.SET_FETCHED_ISDA_MAPPING_OPTIONS: {
            return setFetchedIsdaMappingOptions(action.fetched, state);
        }
        case actions.SET_FETCHED_COMMODITY_MAPPING_OPTIONS: {
            return setFetchedCommodityMappingOptions(action.fetched, state);
        }
        case actions.SET_FETCHED_PRODUCT_CLASS_OPTIONS: {
            return setFetchedProductClassOptions(action.fetched, state);
        }
        case actions.SET_FETCHED_CURRENCY_OPTIONS: {
            return setFetchedCurrencyOptions(action.fetched, state);
        }
        case actions.DELETE_ISDA_ROW: {
            return setIsdaRows(state.isdaRows.filter(row => row.id !== action.id), state);
        }
        case actions.DELETE_COMMODITY_ROW: {
            return setCommodityRows(state.commodityRows.filter(row => row.id !== action.id), state);
        }
        case actions.DELETE_EQUITY_ROW: {
            return setEquitySedolRows(state.equityMappingRows.filter(
                row => row.id !== action.id
            ), state);
        }
        case actions.DELETE_CURRENCY_MAPPING_ROW: {
            return setCurrencyMappingRows(state.currencyMappingRows.filter(
                row => row.id !== action.id
            ), state);
        }
        case actions.EDIT_ISDA_ROW: {
            return setIsdaRows(state.isdaRows.map(row => (row.id === action.id
                ? { ...row, field: action.key, mappedField: action.value } : row)), state);
        }
        case actions.EDIT_COMMODITY_ROW: {
            return setCommodityRows(state.commodityRows.map(row => (row.id === action.id
                ? { ...row, field: action.key, mappedField: action.value } : row)), state);
        }
        case actions.EDIT_EQUITY_ROW: {
            return setEquitySedolRows(state.equityMappingRows.map(row => (row.id === action.id
                ? { ...row, field: action.key, mappedField: action.value } : row)), state);
        }
        case actions.EDIT_PRODUCT_CLASS_ROW: {
            return setProductClassRows(state.standardProductClassRows.map(row => (row.id === action.id
                ? { ...row, field: action.key, mappedField: action.value } : row)), state);
        }
        case actions.EDIT_CURRENCY_MAPPING_ROW: {
            return setCurrencyMappingRows(state.currencyMappingRows.map(row => (row.id === action.id
                ? { ...row, field: action.key, mappedField: action.value } : row)), state);
        }
        case actions.CREATE_ISDA_ROW: {
            const newRows = state.isdaRows.concat({
                field: action.key,
                mappedField: action.value,
                id: action.id
            });
            return {
                ...state,
                isdaRows: sortByField(newRows)
            };
        }
        case actions.CREATE_EQUITY_ROW: {
            const newRows = state.equityMappingRows.concat({
                field: action.key,
                mappedField: action.value,
                id: action.id
            });
            return {
                ...state,
                equityMappingRows: sortByField(newRows)
            };
        }
        case actions.CREATE_COMMODITY_ROW: {
            const newRows = state.commodityRows.concat({
                field: action.key,
                mappedField: action.value,
                id: action.id
            });
            return {
                ...state,
                commodityRows: sortByField(newRows)
            };
        }
        case actions.CREATE_CURRENCY_MAPPING_ROW: {
            const newRows = state.currencyMappingRows.concat({
                field: action.key,
                mappedField: action.value,
                id: action.id
            });
            return {
                ...state,
                currencyMappingRows: sortByField(newRows)
            };
        }
        case actions.SET_ALL_GRIDS_LOADING: {
            return {
                ...state,
                commodityLoading: false,
                equityCreditLoading: false,
                equityMappingLoading: false,
                isdaLoading: false,
                standardProductClassLoading: false,
                currencyMappingLoading: false
            };
        }
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({
                        gridId: action.gridId,
                        gridSort: action.sorting
                    })
                };
            }

            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? fp.set('gridSort', action.sorting, sort) : sort)
                )
            };
        }
        case actions.SET_ALL_GRID_SORTS: {
            return setGridSorting(action.data, state);
        }
        default:
            return state;
    }
}
